// export const BaseUrl = "https://endowment.initstore.com/"

//export const BaseUrl= "https://localhost:7177/" 


export const BaseUrl = "https://sopanambookingapi.initstore.com/"